import { resolveId } from '@medplum/core'
import type { Condition, Reference } from '@medplum/fhirtypes'
import { Diagnosis } from '@seen/core/models/conditions/Diagnosis'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { ConditionCard } from '#src/components/condition/ConditionCard.tsx'
import { HoverCard } from '#src/components/core/hover-card/HoverCard.tsx'
import { HoverCardContent } from '#src/components/core/hover-card/HoverCardContent.tsx'
import { HoverCardTrigger } from '#src/components/core/hover-card/HoverCardTrigger.tsx'
import { Link } from '#src/components/core/Link.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ConditionMention({
  condition: conditionReference,
  className,
  displayOverride,
}: {
  condition: Reference<Condition>
  className?: string
  displayOverride?: string | null
}): JSX.Element {
  const conditionId = resolveId(conditionReference)

  const { data: condition } = useRead(Diagnosis, conditionReference)
  const participantId = resolveId(condition?.subject)
  const conditionUrl = `/Patient/${participantId}/conditions/${conditionId}`

  return (
    <HoverCard openDelay={300} closeDelay={200}>
      <HoverCardTrigger asChild>
        <Link
          to={conditionUrl}
          className={cn(
            'select-none rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px hover:bg-gray-460 group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)] [&&]:no-underline',
            className
          )}
          tabIndex={-1}
        >
          <span>{displayOverride || condition?.title}</span>
        </Link>
      </HoverCardTrigger>
      {condition && (
        <HoverCardContent side="bottom" align="start" className="w-auto">
          <ConditionCard condition={condition} to={conditionUrl} />
        </HoverCardContent>
      )}
    </HoverCard>
  )
}
